import { useMemo } from 'react';
import { Option, OptionDescriptionWrapper } from '../../../ui/register-step/register-step.styles';
import { Typography } from '@shared/ui/typography/typography';
import { useCompanyOptionsParams } from './types';
import { LOADING_OPTION } from './constants';
import { SelectProps } from '@shared/ui/select/types';

export const useCompanyOptions = ({ suggestions, isLoadingSuggestions }: useCompanyOptionsParams) => {
    const options: SelectProps['options'] = useMemo(() => {
        return suggestions.map((organization) => {
            const disabled = !organization.active;
            return {
                label: organization.shortName,
                value: organization.inn,
                hint: `ИНН: ${organization.inn}   КПП: ${organization.kpp}`,
                disabled,
                node: (
                    <Option>
                        <Typography size='body1_short' color={disabled ? 'neutral_20' : 'neutral_90'}>
                            {organization.shortName}
                        </Typography>
                        <OptionDescriptionWrapper>
                            {organization.inn && (
                                <Typography size='caption1' color={disabled ? 'neutral_20' : 'neutral_50'}>
                                    ИНН: {organization.inn}
                                </Typography>
                            )}
                            {organization.kpp && (
                                <Typography size='caption1' color={disabled ? 'neutral_20' : 'neutral_50'}>
                                    КПП: {organization.kpp}
                                </Typography>
                            )}
                        </OptionDescriptionWrapper>
                    </Option>
                ),
            };
        });
    }, [suggestions]);
    return isLoadingSuggestions ? LOADING_OPTION : options;
};
